import { Accordion, AccordionTab } from "primereact/accordion";
import "../../css/Accordion.css";
import { FC } from "react";
import { CustomAccordionInterface } from "app/utils/types";

const CustomAccordion: FC<CustomAccordionInterface> = ({
  header,
  content,
  className,
  headerClassName,
  isPendingProposal = true,
  activeIndex = 0,
  onTabOpen,
}) => (
  <Accordion
    activeIndex={activeIndex}
    onTabOpen={onTabOpen}
    className={`${isPendingProposal ? " pending-proposals " : ""} ${className}  `}
  >
    <AccordionTab header={header} headerClassName={headerClassName}>
      {content}
    </AccordionTab>
  </Accordion>
);
export default CustomAccordion;
